import _typeof from 'babel-runtime/helpers/typeof';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Reflect$has from 'babel-runtime/core-js/reflect/has';
import get from 'lodash/get';

var interpolate = function interpolate(phrase, params) {
  var parts = phrase.split(/(\{\{[^{}]*\}\})/gm);
  var result = parts.map(interpolateBracesToParamsValue(params)).filter(function (item) {
    return item !== '';
  });
  Object.defineProperty(result, 'toString', {
    enumerable: false,
    value: function toString() {
      return this.join('');
    }
  });
  return result;
};

var interpolateBracesToParamsValue = function interpolateBracesToParamsValue(params) {
  return function (part) {
    if (/(^\{\{.*\}\}$)/.test(part)) {
      var key = part.replace(/(^\{\{|\}\}$)/gm, '');
      return _Reflect$has(params, key) ? params[key] : part;
    }
    return part;
  };
};

var chooseFormAndInterpolate = function chooseFormAndInterpolate(singular, plural) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$count = _ref.count,
      count = _ref$count === undefined ? 1 : _ref$count,
      params = _objectWithoutProperties(_ref, ['count']);

  var phrase = Math.abs(count) > 1 ? plural : singular;
  return interpolate(phrase, _extends({
    count: count
  }, params));
};

var selectors = [
// context dots: nesting, msgId dots: nesting
function (context, id) {
  return [].concat(_toConsumableArray((context + '.' + id).split('.')));
},
// context dots: key name, msgId dots: key name
function (context, id) {
  return [context, id];
},
// context dots: key name, msgId dots: nesting
function (context, id) {
  return [context].concat(_toConsumableArray(id.split('.')));
},
// context dots: nesting, msgId dots: key name
function (context, id) {
  return [].concat(_toConsumableArray(context.split('.')), [id]);
}];

var createTranslator = function createTranslator(translations) {
  return function () {
    for (var _len = arguments.length, contextArgs = Array(_len), _key = 0; _key < _len; _key++) {
      contextArgs[_key] = arguments[_key];
    }

    var contextPath = contextArgs.join('.');
    var getTranslationKey = function getTranslationKey(idOfMsg) {
      return contextPath + ':' + idOfMsg;
    };

    var getPhraseOrKey = function getPhraseOrKey(idOfMsg) {
      var msg = void 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(selectors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var select = _step.value;

          if (msg === undefined) {
            msg = get(translations, select(contextPath, idOfMsg));
          } else {
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!msg) {
        if (process.env.NODE_ENV !== 'production') {
          if (msg === '') {
            console.warn(idOfMsg + ' phrase in ' + contextPath + ' context is empty!');
          } else {
            console.warn('There is no ' + idOfMsg + ' phrase in ' + contextPath + ' context!');
          }
        }
        return getTranslationKey(idOfMsg);
      }
      return msg;
    };

    var recognizeUsage = function recognizeUsage(singularPhrase, msgPluralIdOrParams, params) {
      // t()(msg, { params })
      if ((typeof msgPluralIdOrParams === 'undefined' ? 'undefined' : _typeof(msgPluralIdOrParams)) === 'object') {
        return interpolate(singularPhrase, msgPluralIdOrParams);
      }

      // t()(msg, msgPlural, { params })
      if (typeof msgPluralIdOrParams === 'string') {
        return chooseFormAndInterpolate(singularPhrase, getPhraseOrKey(msgPluralIdOrParams), params);
      }

      // t()(msg)
      return singularPhrase;
    };

    return function (msgId, msgPluralIdOrParams, params) {
      if (contextArgs.length === 0) {
        throw new Error('You must provide context to translator');
      }
      if (!get(translations, contextPath)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('There is no ' + contextPath + ' context in translations!');
        }
        return getTranslationKey(msgId);
      }

      var singularPhrase = getPhraseOrKey(msgId);

      return recognizeUsage(singularPhrase, msgPluralIdOrParams, params);
    };
  };
};

export default createTranslator;